<template>
    
   <div class="bannerslim bannervmargin">
    </div>
 
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"

// eslint-disable-next-line no-unused-vars

export default {
  name: "cmpbanner",
  mixins:[multilangmixin],
    

  data(){
      return {

            };
  },

  created(){
    //console.log("created ",this.$options.name, "   lingua: ",this.currentlang);

  },

  computed:{
  

  },


  methods:{


  }

  

}


</script>


 

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    

  .bannervmargin{
    margin-top: 20px;

  }


  @media screen and (min-width: 700px)    {
      /*  schermo desktop */
    

 
      .bannerslim
      {
        margin-left: 0px;
        margin-right: 0px;
        /*max-width: 1200px;*/
        
        min-height: 80px;
        background-image: url("~@/assets/images/riga.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;

      }

  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
  
 

    
    .bannerslim
    {
      margin-left: 0px;
      margin-right: 0px;
      min-height: 80px;
      background-image: url("~@/assets/images/riga.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }


  }


</style>
